import { ref } from 'vue';
import { useApi } from './useApi';
import { getHttpInstance, getApiConfig } from './useApi';
const referrals = ref([]);
const referralCode = ref('');
const totalEarned = ref(0);
const referrerCredit = ref(5);
const refereeCredit = ref(5);
const destinationLink = ref('');
const maxReferralsPerMember = ref(null);
const available = ref(true);
const claimedCount = ref(0);
const featureAvailable = ref(false);
const loaded = ref(false);
function normalise(result) {
    featureAvailable.value = !!result && typeof result === 'object' && !Array.isArray(result) && Object.keys(result).length > 0;
    const list = result?.referrals ?? [];
    referrals.value = list.map((r) => {
        const person = r.referee?.person;
        return {
            name: [person?.firstName, person?.lastName].filter(Boolean).join(' '),
            joined: r.referralUsedDateTime ?? null,
            amount: r.referrerCreditAmount ?? null,
        };
    });
    referralCode.value = result?.referralCode ?? '';
    const apiTotal = result?.totalReferrerCreditAmount ?? null;
    totalEarned.value = apiTotal ?? referrals.value.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
    if (result?.referrerCreditAmount != null)
        referrerCredit.value = result.referrerCreditAmount;
    if (result?.refereeCreditAmount != null)
        refereeCredit.value = result.refereeCreditAmount;
    if (result?.destinationLink)
        destinationLink.value = result.destinationLink;
    if (result?.maxReferralsPerMember != null)
        maxReferralsPerMember.value = result.maxReferralsPerMember;
    available.value = result?.available ?? true;
    claimedCount.value = result?.claimedCount ?? 0;
}
export function useReferrals() {
    const api = useApi();
    function getReferrals(onSuccess = null) {
        api.GET('/Customers/00000000-0000-0000-0000-000000000000/Referrals', (result) => {
            normalise(result);
            loaded.value = true;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function applyCode(code, onResult, onError = null) {
        const url = getApiConfig().api + '/Customers/00000000-0000-0000-0000-000000000000/Referrals/Codes/' + encodeURIComponent(code) + '/ApplyRequests';
        getHttpInstance().post(url, null)
            .then((result) => onResult(result.data))
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => applyCode(code, onResult, onError));
            }
            else if (onError) {
                onError();
            }
        });
    }
    return { referrals, referralCode, totalEarned, referrerCredit, refereeCredit, destinationLink, maxReferralsPerMember, available, claimedCount, featureAvailable, loaded, getReferrals, applyCode };
}
